<script lang="ts">
  import { ImagePreview } from '$provider/models/filePreview/ImagePreview';

  interface Props {
    data: ImagePreview;
  }

  let { data }: Props = $props();
</script>

<div class="image-viewer">
  <img src={data?.data} alt="Screenshot preview" />
</div>

<style>
  img {
    width: 100%;
  }
</style>
